import CatalogDatalayer from '@curry/catalog'
import Catalog from '../models/catalog'
import Category from '../models/category'

export default class CatalogApi {
  constructor({ config, transports }) {
    this.datalayer = new CatalogDatalayer({ config, transports });
  }

  get({ id, locale = 'en_US'  }) {
    return new Promise((resolve, reject) => {
      const args = { id, locale };
      this.datalayer.models[0].findById({ args })
      .then((response) => {
        const catalog = new Catalog(Catalog.format(response.data.catalog));
        const categories = [];
        const products = response.data.products;

        response.data.catalog.categ_prod.forEach((c) => {
          const categ = new Category(Category.format(c));
          const prods = products.filter(p => c.id === p.categ_prod_id);
          
          categ.products = prods;
          if(categ.productsCount > 0) {
            categories.push(categ);
          }
        });
        
        catalog.categories = categories;
        resolve(catalog);
      }).catch(reject);
    })
  }
}